/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MappingPreviewDto
 */
export interface MappingPreviewDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof MappingPreviewDto
     */
    targetFields?: Array<string> | null;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof MappingPreviewDto
     */
    rows?: Array<{ [key: string]: any; }> | null;
}

/**
 * Check if a given object implements the MappingPreviewDto interface.
 */
export function instanceOfMappingPreviewDto(value: object): value is MappingPreviewDto {
    return true;
}

export function MappingPreviewDtoFromJSON(json: any): MappingPreviewDto {
    return MappingPreviewDtoFromJSONTyped(json, false);
}

export function MappingPreviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MappingPreviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'targetFields': json['targetFields'] == null ? undefined : json['targetFields'],
        'rows': json['rows'] == null ? undefined : json['rows'],
    };
}

export function MappingPreviewDtoToJSON(json: any): MappingPreviewDto {
    return MappingPreviewDtoToJSONTyped(json, false);
}

export function MappingPreviewDtoToJSONTyped(value?: MappingPreviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetFields': value['targetFields'],
        'rows': value['rows'],
    };
}

